import { BACKEND_URL } from '@/utils/apiConfig';
/**
 * Image URL utility functions for handling profile pictures and uploaded images
 */

// Cache-bust version: increment after imports to force browser refresh
let cacheBustVersion = Date.now();

/**
 * Force all image URLs to refresh (call after a data import)
 */
export const bustImageCache = () => {
  cacheBustVersion = Date.now();
};

/**
 * Converts a relative image URL to a full URL if needed.
 * Adds cache-busting parameter for uploaded images.
 */
export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}?v=${cacheBustVersion}`;
  }
  return url;
};

/**
 * Gets the full URL for a profile picture
 */
export const getProfilePicUrl = (profilePic) => getImageUrl(profilePic);

export default { getImageUrl, getProfilePicUrl, bustImageCache };
